import { jsx as C } from "react/jsx-runtime";
import { ProductCardHorizontal as w } from "./ProductCardHorizontal/index.js";
import { ProductCardVertical as D } from "./ProductCardVertical/index.js";
/* empty css                                                      */const N = ({
  product: i,
  variant: r,
  hasPlusFriendBadge: l = !1,
  hasPromotionalPrice: f,
  clubPrice: x,
  defaultScListPrice: V,
  hasClub: m,
  isClubClient: v,
  openModal: d,
  promotion: j,
  outOfStock: p,
  addToCartAction: s,
  quantitySelectorAction: z,
  productInCart: H
}) => {
  const b = !!(m && v);
  return /* @__PURE__ */ C("div", { children: r === "vertical" ? /* @__PURE__ */ C(
    D,
    {
      isClubClient: b,
      hasClub: m,
      defaultScListPrice: V,
      hasPromotionalPrice: f,
      product: i,
      variant: r,
      outOfStock: p,
      promotion: j,
      clubPrice: x,
      openModal: d,
      hasPlusFriendBadge: l,
      addToCartAction: s,
      quantitySelectorAction: z,
      productInCart: H
    }
  ) : /* @__PURE__ */ C(
    w,
    {
      openModal: d,
      isClubClient: b,
      hasClub: m,
      defaultScListPrice: V,
      hasPromotionalPrice: f,
      product: i,
      variant: r,
      hasPlusFriendBadge: l,
      outOfStock: p,
      promotion: j,
      clubPrice: x,
      addToCartAction: s,
      quantitySelectorAction: z,
      productInCart: H
    }
  ) });
};
export {
  N as ProductCard
};
